<script setup lang="ts">
/**
 * One row of the Legend / Drawing block lists: a cube glyph (lightning-badged
 * for dynamic blocks, AutoCAD-style) followed by the block name as authored.
 */
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";
import BlockBadgeIcon from "../BlockBadgeIcon.vue";
import type { DwgBlockInfo } from "@/drawing/blocks";

defineProps<{
  block: DwgBlockInfo;
  active: boolean;
}>();

defineEmits<{ (e: "select"): void }>();
</script>

<template>
  <div
    class="block-text-item d-flex align-items-center gap-2 px-2 py-1 rounded cursor-pointer mb-1"
    :class="{ active }"
    @click="$emit('select')"
  >
    <span class="block-item-glyph">
      <BlockBadgeIcon
        v-if="block.isDynamic"
        badge="lightning"
        badge-color="#ffc107"
        :size="16"
        :badge-size="10"
      />
      <PhosphorIcon v-else name="cube" :size="16" />
    </span>
    <span class="block-item-name">{{ block.name }}</span>
  </div>
</template>

<style lang="scss" scoped>
.block-text-item {
  font-size: 0.85rem;
  &:hover {
    background-color: rgba(255, 255, 255, 0.08);
  }
  &.active {
    background-color: var(--canvas-btn-active-bg);
  }
}

.block-item-glyph {
  flex: 0 0 auto;
  display: inline-flex;
  color: rgba(255, 255, 255, 0.7);
}

.block-item-name {
  overflow-wrap: anywhere;
}
</style>
